import { commonViewTexts } from '../common';

const targetName = commonViewTexts.blueprintData;

export const deleteProjectImageDialogViewTexts = {
  title: targetName,
  message: [
    `選択された${targetName}を削除してよろしいですか？`,
    'この操作は取り消すことができず、登録し直すには再度画像をアップロードしカウントする必要があります。'
  ]
} as const;
